import RestService from '../services/rest';

async function getListPowerRange(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/powerRange/list?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function createPowerRange(newPowerRange) {
  return RestService.postAuthenticated(
    'panel/powerRange/create', newPowerRange,
  );
}

async function updatePowerRange(updPowerRange) {
  return RestService.putAuthenticated(
    'panel/powerRange/update', updPowerRange,
  );
}

export default {
  getListPowerRange,
  createPowerRange,
  updatePowerRange,
};
